import { defineTool } from '@/shell/tool';

/** Parents (Flutter `/parents`). */
export default defineTool({
  id: 'parents',
  title: 'Parents',
  summary:
    'Find a parent, and read their children, their lessons and their invoices.',
  section: 'users',
  order: 20,
  icon: 'person',
  owner: '@Drabu',
  permission: 'parents:use',
  routes: () => import('./ParentsPage'),
});
